import { Component, Input, OnInit } from '@angular/core';
import { TreeNode } from 'primeng/primeng';

@Component({
  selector: 'catapp-folder-treeview',
  templateUrl: './folder-treeview.component.html',
  styleUrls: ['./folder-treeview.component.scss'],
})
export class FolderTreeViewComponent implements OnInit {

  private _files: TreeNode[];

  private _extensionIcons = [
    { extensions: ['mp3'], icon: 'fa-file-audio-o' },
    { extensions: ['jpg'], icon: 'fa-file-photo-o' },
    { extensions: ['sh'], icon: 'fa-file-code-o' },
  ];

  @Input()
  set files(val: string[]) {
    this._files = val.map((v) => v.replace(/\/\//g, '/')).sort().reduce(this.reducePath, []);
  }

  constructor() { }

  /**
   * on init
   */
  ngOnInit() {
  }

  reducePath = (nodes: TreeNode[], path: string) => {
    const split = path.split('/');

    if (split.length === 1 && split[0] !== '') {
      return [
        ...nodes,
        {
          label: split[0],
          icon: this.getFileIcon(split[0]),
        },
      ];
    } else if (split.length === 1 && split[0] === '') {
      return [
        ...nodes,
      ];
    }

    if (nodes.findIndex((n) => n.label === split[0]) === -1) {
      return [
        ...nodes,
        {
          label: split[0],
          expanded: true,
          icon: 'fa-folder',
          children: this.reducePath([], split.slice(1).join('/')),
        },
      ];
    }

    // The folder is existing, we need to go one step below
    return nodes.map((n) => {
      if (n.label !== split[0]) {
        return n;
      }
      return Object.assign({}, n, {
        children: this.reducePath(n.children, split.slice(1).join('/')),
      });
    });
  }

  /**
   * Gets file icon
   * @param filename
   * @returns
   */
  getFileIcon(filename: string) {
    const extension: string = this.getFileExtension(filename);
    let icon: string;
    this._extensionIcons.forEach((extIcon) => {
      if (!icon) {
        extIcon.extensions.forEach((ext) => {
          if (ext === extension) {
            icon = extIcon.icon;
          }
        });
      }
    });
    if (icon) {
      return icon;
    }
    return 'fa-folder';
  }

  /* tslint:disable:no-bitwise */
  /**
   * Gets file extension
   * @param filename
   * @returns file extension
   */
  getFileExtension(filename: string): string {
    return filename.slice((filename.lastIndexOf('.') - 1 >>> 0) + 2);
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/userdata-generation/components/folder-treeview/folder-treeview.component.ts